import type { IconType } from '~/components/icons';
import type { AlertBarAppearance } from '~/components/types/appearance';
import { classNames } from '~/utils/styles';
import type { AlertBarIconProps } from '.';
import { Icon } from '../..';

const APPEARANCE_ICONS: { [key in AlertBarAppearance]: IconType } = {
  error: 'ErrorWarningIcon',
  info: 'InformationIcon',
  plain: 'InformationIcon',
  success: 'CheckboxCircleIcon',
  warning: 'WarningIcon',
};

export function AlertBarIcon({ appearance = 'info', className, size = 'large', icon }: AlertBarIconProps) {
  const classes = classNames(
    'relative',
    {
      'text-neutral-1000': appearance === 'plain',
      'text-green-700': appearance === 'success',
      'text-red-700': appearance === 'error',
      'text-technology-anyRenewable': appearance === 'info',
      'text-yellow-700': appearance === 'warning',
    },
    className,
  );
  const sizePx = size === 'small' ? 20 : 24;

  return (
    <Icon className={classes} height={sizePx} icon={icon || APPEARANCE_ICONS[appearance]} role="img" width={sizePx} />
  );
}
